<template>
  <div>
    <!-- 主体部分 -->
    <template>
      <div class="loading-container">
        <div v-show="loading" class="loading-overlay">
          <img class="loading-gif" :src="loadingGif" alt="loading">
        </div>
        <w-table class="wMyTable" ref="wMyTable" :columns="columnList" :table-data="projectData"
                 @getTableSearchSortCon="getTableSearchSortCon"
                 :isPagination="true"
                 :table-col-check="tableColCheck"
                 :isOpenNewSearch="true"
                 :page="page" @pageChange="handlePagePagination">

          <!-- customerName 插槽：外部优先，内部兜底 -->
          <template slot="customerName" slot-scope="scope">
            <slot v-if="hasSlot('customerName')" name="customerName" v-bind="scope"></slot>
            <span v-else>{{ formatCustomerName(scope.text) }}</span>
          </template>

          <!-- projectOrdinal 插槽 -->
          <template slot="projectOrdinal" slot-scope="scope">
            <slot v-if="hasSlot('projectOrdinal')" name="projectOrdinal" v-bind="scope"></slot>
            <span v-else>{{ scope.text }}</span>
          </template>

          <!-- remark 插槽 -->
          <template slot="remark" slot-scope="scope">
            <slot v-if="hasSlot('remark')" name="remark" v-bind="scope"></slot>
            <editable-text-cell v-else
                                :text="scope.text"
                                :max-length="20"
                                edit-tooltip="修改备注"
                                more-tooltip="查看更多信息"
                                :editable="getPermit(scope.record, 'project_edit')"
                                @edit="handleProjectUpdate(scope.record, 'remark')"

            />
          </template>
          <!-- customerRemark 插槽 -->
          <template slot="customerRemark" slot-scope="scope">
            <slot v-if="hasSlot('customerRemark')" name="customerRemark" v-bind="scope"></slot>
            <editable-text-cell v-else
                                :text="scope.text"
                                :max-length="20"
                                edit-tooltip="修改备注"
                                more-tooltip="查看更多信息"
                                :editable="getPermit(scope.record, 'project_customer_edit')"
                                @edit="handleProjectUpdate(scope.record, 'customerRemark')"/>

          </template>
          <!-- 商务系统签署状态插槽 -->
          <template slot="bsSignStatus" slot-scope="scope">
            <slot v-if="hasSlot('bsSignStatus')" name="bsSignStatus" v-bind="scope"></slot>
            <span v-else>
            <el-tag v-if="scope.text" :type="['SIGNED','AUTO'].includes(scope.text)?'success':'danger'">{{
                bsContractChEn[scope.text]
              }}</el-tag>
          </span>
          </template>
          <!--        原始数据状态插槽-->
          <template slot="rawDataStatus" slot-scope="scope">
            <slot v-if="hasSlot('rawDataStatus')" name="rawDataStatus" v-bind="scope"></slot>
            <div v-else>
            <span v-for="i in scope.text"
                  :class="rawDataStatusIconList[i.rawDataStatus]?.class">{{
                rawDataStatusIconList[i.rawDataStatus].displayName
              }}</span>
            </div>
          </template>
          <!--        报告审批状态插槽-->
          <template slot="reportApproval" slot-scope="scope">
            <slot v-if="hasSlot('reportApproval')" name="reportApproval" v-bind="scope"></slot>
            <el-tag v-else :type="scope.text?'success':'info'">{{ scope.text ? '通过' : '待审批' }}</el-tag>
          </template>
          <!--        分析结果状态插槽-->
          <template slot="resReleased" slot-scope="scope">
            <slot v-if="hasSlot('resReleased')" name="resReleased" v-bind="scope"></slot>
            <el-tag v-else :type="scope.record?.bsReleased&&scope.record?.resReleased?'success':'info'">{{
                (scope.record?.bsReleased && scope.record?.resReleased) ? '已释放' : '未释放'
              }}
            </el-tag>
          </template>
          <!-- operation 插槽 -->
          <template slot="operation" slot-scope="scope">
            <slot v-if="hasSlot('operation')" name="operation" v-bind="scope"></slot>
            <div v-else class="operation-btns">
              <!-- 额外操作插槽 -->
              <slot name="extraOperation" v-bind="scope"></slot>
              <el-button v-if="getPermit(scope.record, 'project_changer_user')" type="warning" size="mini"
                         @click="handleChange(scope.record)">更改用户
              </el-button>
              <el-button v-if="getPermit(scope.record, 'projects_share')" class="ml-10" size="mini" type="primary"
                         @click="openShareDialog(scope.record)">分享
              </el-button>
              <el-button v-if="getPermit(scope.record, 'project_del')" class="ml-10" type="danger" size="mini"
                         @click="handleDeleteProject(scope.record)">删除
              </el-button>
            </div>
          </template>

          <!-- filterRawDataStatus 筛选插槽：外部优先，内部兜底 -->
          <template slot="filterRawDataStatus" slot-scope="filterScope">
            <slot v-if="hasSlot('filterRawDataStatus')" name="filterRawDataStatus" v-bind="filterScope"></slot>
            <div v-else class="filter-dropdown">
              <div class="filter-content">
                <el-radio-group v-model="filterScope.selectedKeys[0]">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-radio label="无">无</el-radio>
                    </el-col>
                    <el-col :span="12">
                      <el-radio label="未释放">未释放</el-radio>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-radio label="链接释放">链接释放</el-radio>
                    </el-col>
                    <el-col :span="12">
                      <el-radio label="硬盘释放">硬盘释放</el-radio>
                    </el-col>
                  </el-row>
                </el-radio-group>
              </div>
              <div class="filter-actions">
                <a-button type="primary" icon="search" size="small" class="filter-btn mr-8"
                          @click="() => handleSearch(filterScope.setSelectedKeys, filterScope.selectedKeys, filterScope.confirm, filterScope.column, filterScope.clearFilters)">
                  搜索
                </a-button>
                <a-button size="small" class="filter-btn"
                          @click="() => handleReset(filterScope.column, filterScope.clearFilters)">取消
                </a-button>
              </div>
            </div>
          </template>

          <!-- 动态透传其他自定义插槽 -->
          <template v-for="name in dynamicSlotNames" :slot="name" slot-scope="scope">
            <slot :name="name" v-bind="scope"></slot>
          </template>

        </w-table>

      </div>
    </template>

    <!-- 分享客户管理弹窗 -->
    <share-customer-dialog
        v-if="showShareDialog"
        :show-dialog.sync="showShareDialog"
        :select-detail="selectDetail"
    ></share-customer-dialog>
    <edit-form-info-dialog v-if="showProjectUpdateDialog" :show-dialog.sync="showProjectUpdateDialog"
                           :select-detail="selectDetail"
                           @submitData="updateProject"></edit-form-info-dialog>
    <!-- 更改用户弹窗 -->
    <change-users-dialog
        v-if="showChangeUsersDialog"
        :show-dialog.sync="showChangeUsersDialog"
        :select-detail="selectDetail"
        @submit="handleChangeUsersSubmit"
    ></change-users-dialog>
  </div>
</template>


<script>
import {
  requestProjectDelete,
  requestProjectEditCustomerRemark,
  requestProjectEditRemark,
  requestProjectList,
  requestProjectPage,
  requestProjectBs
} from "./api/project";
import {tableOperationMixin} from "./mixins/table/tableOperation";
// 引入弹窗组件
import ShareCustomerDialog from "./component/ShareCustomerDialog.vue";
import EditRemarkDialog from "./component/EditRemarkDialog.vue";
import EditCustomerRemarkDialog from "./component/EditCustomerRemarkDialog.vue";
import ChangeUsersDialog from "./component/ChangeUsersDialog.vue";
import EditableTextCell from "./component/EditableTextCell.vue";
import '../../utils/tips'
import EditFormInfoDialog from "./component/EditFormInfoDialog.vue";
import {changeFilteredInfo} from "./utils/tableUtil";
import {bsContractChEn, rawDataStatusIconList} from "./utils/dataObj";
import loadingGif from '../../assests/image/loading-load.gif'
import '../../assests/css/golbal.css'

export default {
  name: 'LEProjectIndex',
  props: {
    tableColCheck: {
      isShow: false,
      name: ''
    },
    platName: {
      default: ''
    },
    isNeedBSRequest: {
      default: false
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    filterDownEnum: {
      type: Object,
      default: () => {
        return {
          'rawDataStatus': {
            '无': 'NO_DATA',
            '未释放': 'NOT_RELEASED',
            '链接释放': 'LINK_RELEASED',
            '硬盘释放': 'HDD_RELEASED'
          }
        }
      }
    },
    // 操作按钮权限配置 { change: true, share: true, delete: true } 或函数 (record) => ({ change: true })
    operationPermit: {
      type: [Array, Function],
      default: () => ([])
    },
    noUseNewSearchKey: {
      type: Array,
      default: () => {
        return ['rawDataStatus','analystName','customerName','salesName']
      }
    },
  },
  components: {
    EditFormInfoDialog,
    ShareCustomerDialog,
    EditRemarkDialog,
    EditCustomerRemarkDialog,
    ChangeUsersDialog,
    EditableTextCell
  },
  mixins: [tableOperationMixin],
  data() {
    return {
      loadingGif,
      // 弹窗控制变量
      showShareDialog: false,        // 分享客户弹窗
      showProjectUpdateDialog: false,       // 编辑项目弹窗
      showChangeUsersDialog: false,  // 更改用户弹窗
      selectDetail: null,            // 当前选中的项目详情
      customerOptions: [],           // 客户选项列表
      page: {
        total: 0,
        pageSize: 10,
        currentNum: 1
      },
      projectData: [],
      bsContractChEn: bsContractChEn,
      loading: false,
      filterDownKey: [],
      rawDataStatusIconList: rawDataStatusIconList,
      isOpenNewSearch:true
    }
  },
  computed: {
    // 已显式处理的插槽名称
    handledSlots() {
      return [
        'customerName', 'projectOrdinal', 'remark', 'customerRemark',
        'bsSignStatus', 'rawDataStatus', 'reportApproval', 'resReleased',
        'operation', 'filterRawDataStatus', 'extraOperation'
      ]
    },
    // 需要动态透传的插槽名
    dynamicSlotNames() {
      return Object.keys(this.$scopedSlots).filter(name => !this.handledSlots.includes(name))
    },
    columnList() {
      let columns = structuredClone(this.columns)
      columns = this.getTableFilterColumn(columns, this.searchConditionTag)
      return columns
    }
  },
  mounted() {
    this.filterDownKey = Object.keys(this.filterDownEnum)
    this.getData()
  },
  methods: {
    // 判断外部是否传入了指定插槽
    hasSlot(name) {
      return !!this.$scopedSlots[name]
    },
    // 获取按钮权限
    getPermit(record, key) {
      const permit = typeof this.operationPermit === 'function'
          ? this.operationPermit(record)
          : this.operationPermit
      return permit.some(item => item === key)
    },
    // 格式化客户名称
    formatCustomerName(text) {
      return text ? Array.from(new Set(text.map(item => item.realName))).join(';') : ''
    },
    getTableFilterColumn(column, searchConditionTag) {
      let filteredInfo = changeFilteredInfo(searchConditionTag)
      return column.map(item => {
        return {
          ...item,
          filteredValue: filteredInfo[item.key] || []
        }
      })
    },
    //获取项目列表
    async getData(isInt) {
      this.loading = true
      var params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (isInt) {
        params['page.current'] = 1
        params['page.size'] = 10
      }
      let sendData = {
        'query#platform': this.platName
      }
      let length = this.searchConditionTag.length
      if (length) {
        this.searchConditionTag.forEach(item => {
          let newSearchKey = item.newSearchKey
          let key = item.key
          if(this.noUseNewSearchKey.includes(key)){
            newSearchKey=key
          }
          if (this.filterDownKey?.length > 0 && this.filterDownKey.includes(key)) {
            sendData[newSearchKey] = this.filterDownEnum[key][item.value]
          } else {
            sendData[newSearchKey] = item.value
          }
        })
      }
      params.order = this.sortConditionTag.length > 0 ? `${this.sortConditionTag[0].colName}.${this.sortConditionTag[0].order}` : ''
      requestProjectPage(params, sendData).then(async res => {
        if (res?.code === 200) {
          let projectList = res.data.records
          if (this.isNeedBSRequest) {
            const contractInfoRes = await requestProjectBs(projectList.map(item => item?.contractNo).filter(item => item))
            if (contractInfoRes?.code === 200) {
              const contractInfo = contractInfoRes.data
              projectList = projectList.map(item => {
                return {
                  ...item,
                  bsSignStatus: (contractInfo) ? (contractInfo[item?.contractNo]?.signStatus) : ''
                }
              })
            }
          }
          this.projectData = projectList
          this.loading = false
          this.page.total = Number(res.data.total) || 0
          this.page.pageSize = Number(res.data.size) || 10
          this.page.currentNum = Number(res.data.current) || 1
        }
      })


    },
    // 获取tag的搜索排序的内容
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData(true)
    },
    //页码的变动
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },

    // ========== 分享客户功能 ==========
    // 打开分享客户弹窗
    openShareDialog(record) {
      this.selectDetail = {
        projectId: record.id,
        customerList: record.customerInfos
      }
      this.showShareDialog = true
    },
    handleDeleteProject(record) {
      this.$confirmUi('确定要删除该项目吗？', '删除项目', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        requestProjectDelete([record.id]).then(res => {
          if (res?.code === 200) {
            this.$message.success('删除成功')
            this.getData()
          }
        })
      }).catch(() => {
      })
    },
    // ========== 编辑备注功能 ==========
    // 打开编辑备注弹窗
    handleProjectUpdate(record, type) {
      this.selectDetail = {
        projectId: record.id,
      }
      switch (type) {
        case 'remark':
          this.selectDetail.title = '编辑备注'
          this.selectDetail.form = {
            remark: {
              value: record.remark,
              type: 'textarea',
              label: '项目备注'
            }
          }
          break;
        case 'customerRemark':
          this.selectDetail.title = '编辑备注'
          this.selectDetail.form = {
            customerRemark: {
              value: record.customerRemark,
              type: 'textarea',
              label: '备注'
            }
          }
          break;
      }
      this.showProjectUpdateDialog = true
    },
    // 编辑客户备注提交回调
    async updateProject(data) {
      let res
      if (data.form.hasOwnProperty('customerRemark')) {
        let value = Object.values(data.form)[0]?.value || ' '
        res = await requestProjectEditCustomerRemark(data.projectId, value)
      } else {
        let value = Object.values(data.form)[0]?.value || ' '
        res = await requestProjectEditRemark(data.projectId, value)
      }
      if (res?.code === 200) {
        this.showProjectUpdateDialog = false
        this.$messageUi.success('修改成功')
        this.getData()
      } else {
        this.$message.error('修改失败')
      }
    },

    // ========== 更改用户功能 ==========
    // 打开更改用户弹窗
    handleChange(record) {
      this.selectDetail = {
        projectId: record.id,
        analystUuid: record.analyst?.uuid || '',
        salesUuids: record.sales?.uuid || '',
        customers: record?.customerInfos || []
      }
      this.showChangeUsersDialog = true
    },
    // 更改用户提交回调
    handleChangeUsersSubmit(data) {
      this.getData() // 刷新列表
    }
  }
}
</script>
<style scoped>
/* 通用间距类 */
.ml-10 {
  margin-left: 10px;
}

.mr-8 {
  margin-right: 8px;
}

/* 操作按钮组 */
.operation-btns {
  display: flex;
  align-items: center;
}

/* 筛选下拉框 */
.filter-dropdown {
  padding: 8px;
  position: relative;
  z-index: 9999 !important;
}

.filter-content {
  padding: 5px 15px;
}
.filter-content /deep/ .el-row {
  margin-bottom: 10px!important;
}

.filter-actions {
  display: flex;
  justify-content: center;
  padding-bottom: 10px;

}

.filter-btn {
  width: 90px;
}

/* 表格样式 */
::v-deep .ant-table-empty .ant-table-body {
  overflow-x: visible !important;
  overflow-y: visible !important;
}

::v-deep .ant-table-body {
  overflow-x: auto !important;
}


/deep/ .wMyTable .ant-table-body {
  max-height: 550px !important;
}

/deep/ .viewIcon i {
  color: #2978ca !important;
}


.status-tag {
  display: inline-block;
  font-size: 13px;
  padding: 4px 10px;
  width: 75px;
  text-align: center;
  border-radius: 5px;
  align-items: center;
}

.tag-none {
  background: #e9ecef;
  color: #495057;
  border: 1px solid #dee2e6;
}

.tag-unreleased {
  background: #fff3e8;
  color: #e67b42;
  border: 1px solid #ffe5d0;
}

.tag-link-released {
  background: #e7f1ff;
  color: #2e77e3;
  border: 1px solid #cfe2ff;
}

.tag-disk-released {
  background: #e8f6ef;
  color: #2d9d69;
  border: 1px solid #d1e7dd;
}

/deep/ .ant-table td {
  white-space: nowrap !important;
}

/deep/ .ant-table th {
  white-space: nowrap !important;
}

/deep/ .ant-table-thead {
  position: sticky !important;
  top: 0px !important;
  z-index: 1; /* 保证表头在内容上方 */
  border-top: 1px solid #e8e8e8 !important;
}

/deep/ .ant-table-bordered .ant-table-body > table, /deep/ .ant-table-bordered .ant-table-fixed-left table, /deep/ .ant-table-bordered .ant-table-fixed-right table, /deep/ .ant-table-bordered .ant-table-header > table {
  border-top: 0px solid #e8e8e8 !important;
  border-bottom: 1px solid #e8e8e8;
  border-left: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}

/deep/ .ant-table-tbody {
  border-top: 1px solid #e8e8e8 !important;
}

/deep/ .ant-table-thead > tr > th {
  border-top: 1px solid #e8e8e8;
}

/* Loading 加载层 */
.loading-container {
  position: relative;
  min-height: 150px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  //background-color: #2e77e3;
  background: rgba(255, 255, 255, 0.16);
  z-index: 10;
}

.loading-gif {
  width: 85px;
}
</style>

